import { Items } from 'src/types/item.types';

export const flatItems = (items: Items): string[] => {
  const ids: string[][] = [];
  Object.values(items).forEach((i) => ids.push(i));
  return ids.flat();
};
